import React, { useState, useEffect } from 'react'
import "./ScrollToTop.css";

const ScrollToTop = () => {
    const [showTopBtn, setShowTopBtn] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    return (
        <div className="top-to-btm">
            {showTopBtn && (
                <span
                    className="icon-position icon-style"
                    onClick={goToTop}><i className='bi bi-arrow-up-circle-fill'></i>
                </span>
            )}
        </div>
    );
};
export default ScrollToTop;